import ConditionsBody from './ConditionsBody';

export default ConditionsBody;
